import clsx from "clsx";
import React, { useState } from "react";
import PinchZoomImage from "../../PinchZoomImage";

type Props = {
  title?: string;
  onBackClick?: () => void;
  rightContent?: React.ReactNode;
  selectContent?: React.ReactNode;
  backgroundColor?: string;
  className?: string;
  backIcon?: React.ReactNode;
  backIconColor?: string;
  image?: File | string;
  style?: { [key: string]: string };
};

export default function StickyHeader({
  title,
  onBackClick,
  rightContent,
  selectContent,
  className,
  backIcon,
  backIconColor,
  image,
  style,
  backgroundColor = "white",
}: Props) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleImageClick = () => {
    if (image !== undefined) {
      setIsModalOpen(true);
    }
  };

  return (
    // 사파리 브라우저에서 스크롤 시 sticky 헤더가 흔들리는 문제 발생
    // will-change-transform(하드웨어 가속 처리) 클래스 적용으로 위 렌더링 이슈를 해결했으나 이후 더 좋은 방법이 있을 경우 수정 필요
    // 하드웨어 가속 처리가 적용된 요소는 별도의 레이어로 처리되기 때문에 PinchZoomImage 팝업에 문제가 발생. 해당 요소와 분리하여 해결. 지라 티켓 #1327 참고.
    <>
      <header
        className={clsx([
          "sticky top-0 flex items-center gap-3 py-4 justify-between bg-white z-30 will-change-transform",
          className,
        ])}
        onClick={handleImageClick}
        style={{
          ...style,
          backgroundColor,
        }}
      >
        <div className="flex items-center gap-3 w-full">
          {onBackClick && (
            <button onClick={onBackClick}>
              {backIcon || <StickyHeaderBackIcon strokeColor={backIconColor} />}
            </button>
          )}
          <span className="text-lg font-semibold">{title}</span>
          {selectContent && <div className="flex-grow">{selectContent}</div>}
        </div>
        {rightContent && (
          <div>
            <div className="flex items-center gap-2">{rightContent}</div>
          </div>
        )}
      </header>
      {isModalOpen && image && (
        <PinchZoomImage
          imageList={[image]}
          isOpen={isModalOpen}
          onClose={(e: React.MouseEvent) => {
            e.stopPropagation(); // 이벤트 버블링을 중단합니다.
            setIsModalOpen(false);
          }}
        />
      )}
    </>
  );
}

export type StickyHeaderBackIconProps = {
  strokeColor?: string;
};

export const StickyHeaderBackIcon = ({
  strokeColor = "black",
}: StickyHeaderBackIconProps) => (
  <svg
    data-testid="sticky-header-back-icon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 12H6.29895"
      stroke={strokeColor}
      strokeWidth="1.75"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M12 19L5 12L12 5"
      stroke={strokeColor}
      strokeWidth="1.75"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </svg>
);
